import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  const gridArr = data.itgListing ? get(data, 'itgListing', []) : []
  return {
    background: get(data, 'itgBackground', null),
    preTitle: get(data, 'itgPretitle', null),
    title: get(data, 'itgTitle', null),
    listing: gridArr.map(item => {
      const image = item.image ? refactorRespImg(item.image, [{
        size: 'default',
        key: 'image_size_200x200',
      }]): null;
      return {
        title: get(item, 'title', null),
        text: get(item, 'text', null),
        image,
        link: {
          'title': get(item, 'link.title', null),
          'href': get(item, 'link.url', null),
          'tagret': get(item, 'link.target', null),
          "assignedDomains": [
            "jayco.com.au",
            "jayco.co.nz",
            "AU-dealers",
            "NZ-dealers"
          ]
        }
      }
    })
  }
}
